import React, { useState } from "react";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import classNames from "classnames";
import { motion, AnimatePresence } from "framer-motion";
import { useUserInfoStore } from "@/store/userInfoStore";
import { useReferalProgramsDataContext } from "@/store/ReferalProgramsProvider";
import {
  activeReferalProgramsThisDay,
  maxAmountRefProgramByCategory,
} from "@/utils/helpers";
import cls from "./styles.module.scss";
import { dataTrigger } from "@/analytics";

interface InstructionBlockProps {
  isBlockOpen?: boolean;
}

export const InstructionBlock = ({
  isBlockOpen = false,
}: InstructionBlockProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(isBlockOpen);
  const serviceType = useUserInfoStore((s) => s.serviceType);

  const { referalPrograms } = useReferalProgramsDataContext();
  const filteredReferalPrograms = activeReferalProgramsThisDay(referalPrograms);
  const maxAmount = maxAmountRefProgramByCategory(
    filteredReferalPrograms,
    serviceType
  );

  const listLabels = [
    "Ниже возьми свою уникальную реферальную ссылку (или используй QR‑код).",
    "Отправьте её другу, который ищет быстрый и высокий доход.",
    `Как только друг зарегистрируется по твоей ссылке и сделает поездки - ты получишь до ${maxAmount}₽.`,
  ];

  const listVariants = {
    hidden: {
      opacity: 0,
      y: -20,
      height: 0,
      transition: {
        duration: 0.2,
        when: "afterChildren",
      },
    },
    visible: {
      opacity: 1,
      y: 0,
      height: "auto",
      transition: {
        duration: 0.3,
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
    exit: {
      opacity: 0,
      y: -20,
      height: 0,
      transition: {
        duration: 0.2,
        when: "afterChildren",
      },
    },
  };
  return (
    <FlexColumn gap={16} className={cls.instructionBlock}>
      <FlexRow
        justifyContent="space-between"
        className={cls.instructionHeader}
        onClick={() => setIsOpen(!isOpen)}
        role="switch"
        aria-checked={isOpen}
        {...dataTrigger("ref.instructions.toggle")}
      >
        <Typography className={cls.label}>
          Как работает реферальная программа?
        </Typography>
        <div className={classNames(cls.closeBtn, isOpen && cls.activeBtn)}>
          +
        </div>
      </FlexRow>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className={cls.list}
            variants={listVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            {listLabels.map((elem, index) => (
              <FlexRow
                key={index}
                gap={12}
                alignItems="flex-start"
                className={cls.instructionItem}
              >
                <div className={cls.numberItem}>{index + 1}</div>
                <div>{elem}</div>
              </FlexRow>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </FlexColumn>
  );
};
